import * as React from "react"
import SvgIcon from "@mui/material/SvgIcon"

export default function SvgIconChildren() {
  return (
    <SvgIcon>
      {/* credit: cog icon from https://heroicons.com */}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 284 284">
        <defs>
          <clipPath clipPathUnits="userSpaceOnUse" id="cp1">
            <path d="m141.42 13.2c-71.57 0.41-129.45 58.56-129.45 130.22 0 71.92 58.3 130.23 130.23 130.23 71.92 0 130.24-58.31 130.24-130.23 0-71.66-57.9-129.81-129.47-130.22z" />
          </clipPath>
          <linearGradient id="P" gradientUnits="userSpaceOnUse" />
          <radialGradient
            id="g1"
            cx="0"
            cy="0"
            r="1"
            href="#P"
            gradientTransform="matrix(244.04,0,0,244.04,67.341,50.016)"
          >
            <stop stopColor="#fedb9d" />
            <stop offset=".16" stopColor="#fedb9d" />
            <stop offset=".47" stopColor="#fbae17" />
            <stop offset=".98" stopColor="#f89c1b" />
            <stop offset="1" stopColor="#f89c1b" />
          </radialGradient>
        </defs>
        <path
          fill="#fefefe"
          d="m281.1 143.4c0 76.7-62.2 138.9-138.9 138.9-76.7 0-138.9-62.2-138.9-138.9 0-76.7 62.2-138.9 138.9-138.9 76.7 0 138.9 62.2 138.9 138.9z"
        />
        <g clipPath="url(#cp1)">
          <path fill="url(#g1)" d="m12 13.2h260.4v260.4h-260.4z" />
        </g>
        <path
          fillRule="evenodd"
          fill="#00507d"
          d="m79.4 144.3h-15c0.1 1.9 0.3 3.3 1.4 4.4 1.1 1.1 2.4 1.5 4.2 1.5 2.3 0 4.2-1.1 5.4-2.4l3.9 3.6c-0.9 0.8-2.2 1.8-3.9 2.5-2 0.8-4.2 1.3-6.1 1.3-3.4 0-6.1-1.1-8-3.3-2-2.2-2.9-5.2-2.9-9.1 0-3.9 0.8-7.3 2.9-9.7 2.2-2.4 5-3.3 8-3.3 3.2 0 5.7 1.1 7.6 3.2q2.9 3.2 2.9 8.1 0 1-0.4 3.2zm-5.5-4.1c-0.4-3.6-1.5-5.3-4.7-5.3-2.9 0-4.2 1.7-4.9 5.3z"
        />
        <path
          fill="#00507d"
          d="m105.2 153.4c1.4 1.3 2.4 1.7 4.3 1.7 2.2 0 2.2 0.1 4 0l-0.1-5.4c-1.3 0.1-2.3 0.3-3.6-0.1-0.8-0.2-0.9-1.2-0.9-3.2v-10.7h4.5v-4.8h-4.5v-7.5h-6.1l0.1 7.5h-2.5l-0.1 4.8h2.5l-0.1 12.4c0 2 1 4 2.5 5.3z"
        />
        <path
          fillRule="evenodd"
          fill="#00507d"
          d="m139.1 144.3h-14.9c0 1.9 0.2 3.3 1.3 4.4 1.1 1.1 2.4 1.5 4.3 1.5 2.3 0 4.2-1.1 5.4-2.4l3.8 3.6c-0.8 0.8-2.2 1.8-3.9 2.5-1.9 0.8-4.2 1.3-6.1 1.3-3.3 0-6-1.1-8-3.3-1.9-2.2-2.8-5.2-2.8-9.1 0-3.9 0.8-7.3 2.9-9.7 2.1-2.4 5-3.3 8-3.3q4.7 0 7.6 3.2 2.9 3.2 2.9 8.1 0 1-0.5 3.2zm-5.5-4.1c-0.3-3.6-1.5-5.3-4.7-5.3-2.9 0-4.2 1.7-4.9 5.3z"
        />
        <path
          fillRule="evenodd"
          fill="#00507d"
          d="m226.2 144.3h-15c0.1 1.9 0.3 3.3 1.4 4.4 1.1 1.1 2.4 1.5 4.2 1.5 2.3 0 4.2-1.1 5.4-2.4l3.8 3.6c-0.8 0.8-2.2 1.8-3.8 2.5-1.9 0.8-4.3 1.3-6.1 1.3-3.4 0-6.1-1.1-8.1-3.3-1.9-2.2-2.8-5.2-2.8-9.1 0-3.9 0.8-7.3 2.9-9.7 2.2-2.4 5-3.3 8-3.3q4.7 0 7.6 3.2 2.9 3.2 2.9 8.1 0 1-0.4 3.2zm-5.6-4.1c-0.3-3.6-1.4-5.3-4.6-5.3-2.9 0-4.2 1.7-4.9 5.3z"
        />
        <path
          fill="#00507d"
          d="m88.5 153.4c1.4 1.3 2.4 1.7 4.4 1.7 2.2 0 2.2 0.1 3.9 0v-5.4c-1.3 0.1-2.4 0.3-3.6-0.1-0.9-0.2-1-1.2-1-3.2l0.1-10.7h4.4v-4.8h-4.4v-7.5h-6.1v7.5h-2.5v4.8h2.4v12.4c0 2 1 4 2.4 5.3z"
        />
        <path
          fill="#00507d"
          d="m258.7 149.7c-1.3 0.1-2.4 0.3-3.7-0.1-0.8-0.2-0.9-1.2-0.9-3.2v-10.7h4.5v-4.8h-4.4v-7.5h-6.1v7.5h-2.5v4.8h2.4v12.4c0 2 1 4 2.4 5.3 1.4 1.3 2.4 1.7 4.3 1.7 2.2 0 2.2 0.1 4 0z"
        />
        <path
          fill="#00507d"
          d="m234.3 153.4c1.4 1.3 2.4 1.7 4.3 1.7 2.2 0 2.3 0.1 4 0v-5.4c-1.3 0.1-2.4 0.3-3.7-0.1-0.8-0.2-0.9-1.2-0.9-3.2v-10.7l0.1-4.8v-10h-6.1v10l-0.1 4.8v12.4c0 2 1 4 2.4 5.3z"
        />
        <path
          fill="#00507d"
          d="m152.8 136.2c1.2-1 2.3-1 3.9-0.7 1.2 0.3 1.3 0.9 2.1 1.3l4.7-4.7c-1-0.9-3.3-2.2-5.3-2.3-2.6-0.1-4.2-0.1-6.6 2.7v-2.6h-6.4l0.1 25.2h6.3v-14c0-2.1-0.4-3.6 1.2-4.9z"
        />
        <path
          fill="#00507d"
          d="m79.9 52.7q4.5-2.8 9.6-4c29.2-7.4 62.7 25.1 74.5 72.4l8.6 34h5.1l6.6-20.8 6.3 20.9h5.4l9.2-34h-6.7l-5.6 20.3-5.8-20.4-5.3-0.1-6.1 20.5-5.3-20.4h0.1c-0.2-0.5-0.3-1-0.4-1.5-1.4-5.7-3.2-11.1-5.1-16.4l5.8-14.8c0.3-0.6-9.8-3.6-15.5-5.4-3.3-5.6-6.9-10.8-10.8-15.5l-0.3-17.5c0-0.7-12 0.5-17.6 1.1-8.2-5.6-16.8-8.9-25.4-9.6 12.7-5.1 26.5-7.8 40.9-7.8 33.9 0 64.2 15.2 84.7 39.1l4.6-4c-4.2-4.9-8.8-9.5-13.7-13.6 1.3-1.9 1.6-4.5 1.6-6.7 0-4.8-4.9-10-10.6-10-3.4 0-7 1.7-9.2 4.1-10-5.7-21-9.9-32.5-12.4 0-2.1-0.7-4.2-1.5-6-2-4.4-8.6-7-13.8-4.6-3.2 1.5-5.9 4.8-6.7 8q-1.4-0.1-2.9-0.1c-50.7 0-93.9 32.3-110.4 77.4l5.8 2.1c8.1-22.3 23.1-41.2 42.4-54.3z"
        />
        <path
          fill="#00507d"
          d="m247.1 182c-11.5 32.4-37.6 58-70.4 68.8 0.3-3.3-2.4-6.1-4.9-8-4.1-3-11.7-2.4-15.5 2.2-2.4 3-3.4 7.3-2.5 10.6q-0.7 0.1-1.4 0.2l-13.2-14.4c-0.6-0.5-10.1 10.2-13.3 13.7-17.9-2.6-34.4-9.6-48.5-19.7 1-1.5 1.4-3.5 1.8-5.5 1-5.1-3.5-12.1-9.6-13.2-3.5-0.7-7.6 0.5-10.3 2.5l-0.5-0.6 3.9-18.3c0.2-0.7-14.2-2.4-18.8-3-6.9-12.9-11.3-27.4-12.7-42.7l6.5-20.5 6.3 20.9h5.4l9.1-34h-6.6l-5.6 20.3-5.8-20.4-5.3-0.2-6.1 20.6-5.3-20.4h-6.8l8 32c4.1 61 55 109.5 117.1 109.5 51.2 0 94.8-32.9 110.9-78.7l-0.6 0.2z"
        />
      </svg>
    </SvgIcon>
  )
}
